import { createEventTracker } from '../util';
import { PageSuggestions, AutoIndexingAnalytics } from './types';

export const trackPageSuggestions = createEventTracker<PageSuggestions>(
  'Object Picker Page Suggestions',
);

export const trackAutoIndexing = createEventTracker<AutoIndexingAnalytics>(
  'Object Picker Auto-Indexing',
);
